import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function useRequireAuthorization(identityAuthorized, setLoading) {
    const navigate = useNavigate();
  
    useEffect(() => {
      let isMounted = true;
      setLoading(true);
      identityAuthorized().then((res) => {
        if (!isMounted) return;
        setLoading(false);
        if (res === undefined || !res.authorized) {
          navigate("/paymentcheck/login");
        }
      });
      return () => { isMounted = false; };
    }, [navigate, identityAuthorized, setLoading]);
  }